export default {
  state: {
    optin: {
      leg1: {
        enabled: false,
        total: 0,
        shared: []
      },
      leg2: {
        enabled: false,
        total: 0,
        shared: []
      },
      sharedAllowedTime: {
        start: '',
        end: ''
      }
    }
  },
  mutations: {
    setOptinData (state, data) {
      for (let field in data.fields) {
        state.optin[data.leg][field] = data.fields[field]
      }
    },
    addSharedService (state, data) {
      state.optin[data.leg].shared.push(data.value)
    },
    setOptinAllowedTime (state, value) {
      state.optin.sharedAllowedTime = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/optin.js